// Preferir REACT_APP_GOOGLE_MAPS_KEY en .env para distintos entornos.
// El error "This page can't load Google Maps correctly" suele deberse a:
// - API key inválida o restringida en Google Cloud
// - Dominio/referrer no permitido en las restricciones de la clave
export default {
  mapsKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || "AIzaSyCnn3b67SfSVsASul4gFMDR68NNESnkm0Q",
};